import { NavigateFunction } from 'react-router-dom';

let globalNavigate: NavigateFunction | null = null;

export const setGlobalNavigate = (navigate: NavigateFunction) => {
  globalNavigate = navigate;
};

export const navigateToLogin = () => {
  if (globalNavigate) {
    globalNavigate('/login');
  } else {
    console.error('Navigation function is not initialized.');
  }
};